export default __webpack_public_path__ + "static/media/icon_mail copy.5ca0b049.svg";